import { render, staticRenderFns } from "./InventoryItemPackage.vue?vue&type=template&id=8ca631e8&scoped=true"
import script from "./InventoryItemPackage.vue?vue&type=script&lang=js"
export * from "./InventoryItemPackage.vue?vue&type=script&lang=js"
import style0 from "./InventoryItemPackage.vue?vue&type=style&index=0&id=8ca631e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca631e8",
  null
  
)

export default component.exports